export default __webpack_public_path__ + "static/media/next-icon.e612b3b5.svg";